/* tslint:disable */
/* eslint-disable */
/**
 * K1 OpenAPI
 * API fuer die Nutzung der K1 REST-Schnittstelle
 *
 * The version of the OpenAPI document: 1.156.0
 * Contact: diplan-backend@init.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { ErrorRest } from '../models';
// @ts-ignore
import { ExterneUrlsRest } from '../models';
// @ts-ignore
import { PlanInfoRest } from '../models';
// @ts-ignore
import { ValidationReceipt } from '../models';
// @ts-ignore
import { ValidationReportAsyncRest } from '../models';
// @ts-ignore
import { ValidationReportRest } from '../models';
// @ts-ignore
import { ValidationStatusRest } from '../models';
// @ts-ignore
import { XplanDokumentRest } from '../models';
// @ts-ignore
import { XplanDokumentVerfahrensstandValidationRest } from '../models';
// @ts-ignore
import { XplanManagerStatusMessageRest } from '../models';
/**
 * XplanManagerResourceApi - axios parameter creator
 * @export
 */
export const XplanManagerResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird ein Planwerk in der XPlanBox gelöscht. Das Verfahren im Cockpit wird aktualisiert.</p><p><b>Benötigte Rechte:</b> PLANWERKE_WRITE or EIGENE_PLANWERKE_WRITE or ADMIN</p>
         * @summary Endpunkt zum Löschen eines Planwerks in der XPlanBox.
         * @param {string} planID die Cockpit PlanID (nicht zu verwechseln mit der PlanID in der XPlanBox)
         * @param {string} fileID FileID vom Planwerk
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteXplanGml: async (planID: string, fileID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('deleteXplanGml', 'planID', planID)
            // verify required parameter 'fileID' is not null or undefined
            assertParamExists('deleteXplanGml', 'fileID', fileID)
            const localVarPath = `/verfahren/{planID}/xplanmanager/{fileID}`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"fileID"}}`, encodeURIComponent(String(fileID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden die URLs für die WFS- und WMS-Dienste für das angegebene Verfahren geliefert.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt der die URLs für die WMS- und WFS-Dienste eines Verfahrens liefert.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} fileID FileID vom Planwerk
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllXplanExterneUrls: async (planID: string, fileID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('getAllXplanExterneUrls', 'planID', planID)
            // verify required parameter 'fileID' is not null or undefined
            assertParamExists('getAllXplanExterneUrls', 'fileID', fileID)
            const localVarPath = `/verfahren/{planID}/xplanmanager/{fileID}/urls`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"fileID"}}`, encodeURIComponent(String(fileID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden Metadaten aller Planwerk aus der XPlanBox ausgeliefert.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt der Metadaten aller Planwerke aus der XPlanBox ausliefert.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllXplanGml: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/verfahren/xplanmanager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird der Verfahrensstand vom Verfahren gegen den Rechtsstand und PlanStatus von veröffentlichen Planwerken geprüft.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zur Prüfung des Rechtsstandes und PlanStatus von veröffentlichten Planwerken zum Verfahrensstand des Verfahrens.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} [codeVerfahrensstand] Verfahrensstand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedXplanDokumentVerfahrensstandValidation: async (planID: string, codeVerfahrensstand?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('getPublishedXplanDokumentVerfahrensstandValidation', 'planID', planID)
            const localVarPath = `/verfahren/{planID}/xplanmanager/verfahrensstandvalidation`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (codeVerfahrensstand !== undefined) {
                localVarQueryParameter['codeVerfahrensstand'] = codeVerfahrensstand;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Liefert den ValidationReport zu einem XplanDokument.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zum Abruf eines ValidationReports.
         * @param {string} planID planID des Verfahrens
         * @param {string} fileID fileID des XPlanGmlArchivs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidationReport: async (planID: string, fileID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('getValidationReport', 'planID', planID)
            // verify required parameter 'fileID' is not null or undefined
            assertParamExists('getValidationReport', 'fileID', fileID)
            const localVarPath = `/verfahren/{planID}/xplanmanager/{fileID}/validationreport`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"fileID"}}`, encodeURIComponent(String(fileID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird der Verfahrensstand vom Verfahren gegen den Rechtsstand und PlanStatus eines spezifischen Planwerks geprüft.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zur Prüfung des Rechtsstandes und PlanStaus eines spezifischen Planwerks zum Verfahrensstand des Verfahrens.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} fileID FileID vom Planwerk
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVerfahrensstandValidation: async (planID: string, fileID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('getVerfahrensstandValidation', 'planID', planID)
            // verify required parameter 'fileID' is not null or undefined
            assertParamExists('getVerfahrensstandValidation', 'fileID', fileID)
            const localVarPath = `/verfahren/{planID}/xplanmanager/{fileID}/verfahrensstandvalidation`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"fileID"}}`, encodeURIComponent(String(fileID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Liefert Updates des XplanDokuments beispielsweise während des Validierungs- und PublicationProzess in Form von Server Sent Events.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zum Abruf von Updates des XplanDokuments während des Validierungs- und PublicationProzess.
         * @param {string} planID planID des Verfahrens
         * @param {string} fileID fileID des XPlanGmlArchivs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listenForXPlanDokumentUpdates: async (planID: string, fileID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('listenForXPlanDokumentUpdates', 'planID', planID)
            // verify required parameter 'fileID' is not null or undefined
            assertParamExists('listenForXPlanDokumentUpdates', 'fileID', fileID)
            const localVarPath = `/verfahren/{planID}/xplanmanager/{fileID}/updates`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"fileID"}}`, encodeURIComponent(String(fileID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Liefert Updates des XplanDokuments während des Validierungsprozesses in Form vom Server Sent Events.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zum Abruf von Updates des XplanDokuments während des Validierungsprozesses.
         * @param {string} planID planID des Verfahrens
         * @param {string} fileID fileID des XPlanGmlArchivs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listenForXPlanGmlValidationUpdates: async (planID: string, fileID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('listenForXPlanGmlValidationUpdates', 'planID', planID)
            // verify required parameter 'fileID' is not null or undefined
            assertParamExists('listenForXPlanGmlValidationUpdates', 'fileID', fileID)
            const localVarPath = `/verfahren/{planID}/xplanmanager/validationupdates/{fileID}`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"fileID"}}`, encodeURIComponent(String(fileID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine im System vorhandenes Planwerk in der XPlanBox veröffentlicht.</p><p><b>Benötigte Rechte:</b> PLANWERKE_WRITE or EIGENE_PLANWERKE_WRITE or ADMIN</p>
         * @summary Endpunkt zum Veröffentlichen eines Planwerks in der XPlanBox.
         * @param {string} planID planID des Verfahrens
         * @param {string} fileID fileID des XPlanGmlArchivs
         * @param {PublishXPlanGmlXplanPlanstatus} xplanPlanstatus PlanInfo.PlanStatusEnum des Planwerks
         * @param {boolean} [skipSemantisch] Semantische Validierung überspringen
         * @param {boolean} [skipFlaechenschluss] Flaechenschluss Validierung überspringen
         * @param {boolean} [skipGeltungsbereich] Geltungsbereich Validierung überspringen
         * @param {boolean} [skipLaufrichtung] Laufrichtung Validierung überspringen
         * @param {boolean} [overwrite] Ggf vorhandenes XplanGML im XplanManager ueberschreiben
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishXPlanGml: async (planID: string, fileID: string, xplanPlanstatus: PublishXPlanGmlXplanPlanstatus, skipSemantisch?: boolean, skipFlaechenschluss?: boolean, skipGeltungsbereich?: boolean, skipLaufrichtung?: boolean, overwrite?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('publishXPlanGml', 'planID', planID)
            // verify required parameter 'fileID' is not null or undefined
            assertParamExists('publishXPlanGml', 'fileID', fileID)
            // verify required parameter 'xplanPlanstatus' is not null or undefined
            assertParamExists('publishXPlanGml', 'xplanPlanstatus', xplanPlanstatus)
            const localVarPath = `/verfahren/{planID}/xplanmanager/{fileID}/publishXPlanGml`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"fileID"}}`, encodeURIComponent(String(fileID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xplanPlanstatus !== undefined) {
                localVarQueryParameter['xplanPlanstatus'] = xplanPlanstatus;
            }

            if (skipSemantisch !== undefined) {
                localVarQueryParameter['skipSemantisch'] = skipSemantisch;
            }

            if (skipFlaechenschluss !== undefined) {
                localVarQueryParameter['skipFlaechenschluss'] = skipFlaechenschluss;
            }

            if (skipGeltungsbereich !== undefined) {
                localVarQueryParameter['skipGeltungsbereich'] = skipGeltungsbereich;
            }

            if (skipLaufrichtung !== undefined) {
                localVarQueryParameter['skipLaufrichtung'] = skipLaufrichtung;
            }

            if (overwrite !== undefined) {
                localVarQueryParameter['overwrite'] = overwrite;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt können Rasterdaten zu einem Planwerk ausgetauscht werden.<br>  Die vorhandenen Rasterdaten am Planwerk werden komplett entfernt.</p><p><b>Benötigte Rechte:</b> PLANWERKE_WRITE or EIGENE_PLANWERKE_WRITE or ADMIN</p>
         * @summary Endpunkt zum Austauschen von Rasterdaten eines Planwerks in der XPlanBox.
         * @param {Array<File>} file Rasterdateien die ausgetauscht werden sollen
         * @param {string} planID ID vom Verfahren
         * @param {string} fileID FileID vom Planwerk
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadRasterdaten: async (file: Array<File>, planID: string, fileID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadRasterdaten', 'file', file)
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('uploadRasterdaten', 'planID', planID)
            // verify required parameter 'fileID' is not null or undefined
            assertParamExists('uploadRasterdaten', 'fileID', fileID)
            const localVarPath = `/verfahren/{planID}/xplanmanager/{fileID}/rasterdaten`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"fileID"}}`, encodeURIComponent(String(fileID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (file) {
                file.forEach((element) => {
                    localVarFormParams.append('file', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Optional kann das Planwerk in der XPlanBox veröffentlicht werden.<br><br> Mit diesem Endpunkt wird ein Planwerk in das System hochgeladen.<br> Optional kann das Planwerk in der XPlanBox über den Parameter publish veröffentlicht werden.</p><p><b>Benötigte Rechte:</b> PLANWERKE_WRITE or EIGENE_PLANWERKE_WRITE or ADMIN</p>
         * @summary Endpunkt zum Hochladen eines Planwerks in das System.
         * @param {File} file das XPlanGmlArchiv
         * @param {string} planID planID des Verfahrens
         * @param {UploadXPlanGmlXplanPlanstatus} [xplanPlanstatus] PlanInfo.PlanStatusEnum des Planwerks
         * @param {boolean} [overwrite] Ggf vorhandenes XplanGML im XplanManager ueberschreiben
         * @param {boolean} [publish] true wenn die XplanGML im XplanManager veroeffentlicht werden soll, sonst false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadXPlanGml: async (file: File, planID: string, xplanPlanstatus?: UploadXPlanGmlXplanPlanstatus, overwrite?: boolean, publish?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadXPlanGml', 'file', file)
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('uploadXPlanGml', 'planID', planID)
            const localVarPath = `/verfahren/{planID}/xplanmanager/uploadXPlanGml`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xplanPlanstatus !== undefined) {
                localVarQueryParameter['xplanPlanstatus'] = xplanPlanstatus;
            }

            if (overwrite !== undefined) {
                localVarQueryParameter['overwrite'] = overwrite;
            }

            if (publish !== undefined) {
                localVarQueryParameter['publish'] = publish;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird ein Planwerk in der XPlanBox synchron validiert.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zum Validieren eines Planwerks in der XPlanBox.
         * @param {string} planID planID des Verfahrens
         * @param {string} fileID fileID des XPlanGmlArchivs
         * @param {boolean} [skipSemantisch] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipGeometrisch] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipFlaechenschluss] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipGeltungsbereich] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipLaufrichtung] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {string} [name] Optionale Angabe eines Namens fuer den zu generierenden Report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateXPlanGml: async (planID: string, fileID: string, skipSemantisch?: boolean, skipGeometrisch?: boolean, skipFlaechenschluss?: boolean, skipGeltungsbereich?: boolean, skipLaufrichtung?: boolean, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('validateXPlanGml', 'planID', planID)
            // verify required parameter 'fileID' is not null or undefined
            assertParamExists('validateXPlanGml', 'fileID', fileID)
            const localVarPath = `/verfahren/{planID}/xplanmanager/{fileID}/validateXplanGml`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"fileID"}}`, encodeURIComponent(String(fileID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (skipSemantisch !== undefined) {
                localVarQueryParameter['skipSemantisch'] = skipSemantisch;
            }

            if (skipGeometrisch !== undefined) {
                localVarQueryParameter['skipGeometrisch'] = skipGeometrisch;
            }

            if (skipFlaechenschluss !== undefined) {
                localVarQueryParameter['skipFlaechenschluss'] = skipFlaechenschluss;
            }

            if (skipGeltungsbereich !== undefined) {
                localVarQueryParameter['skipGeltungsbereich'] = skipGeltungsbereich;
            }

            if (skipLaufrichtung !== undefined) {
                localVarQueryParameter['skipLaufrichtung'] = skipLaufrichtung;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird ein Planwerk in der XPlanBox asynchron validiert.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zum asynchronen Validieren eines Planwerks in der XPlanBox.
         * @param {string} planID planID des Verfahrens
         * @param {string} fileID fileID des XPlanGmlArchivs
         * @param {boolean} [skipSemantisch] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipGeometrisch] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipFlaechenschluss] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipGeltungsbereich] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipLaufrichtung] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {string} [name] Optionale Angabe eines Namens fuer den zu generierenden Report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateXPlanGmlAsync: async (planID: string, fileID: string, skipSemantisch?: boolean, skipGeometrisch?: boolean, skipFlaechenschluss?: boolean, skipGeltungsbereich?: boolean, skipLaufrichtung?: boolean, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('validateXPlanGmlAsync', 'planID', planID)
            // verify required parameter 'fileID' is not null or undefined
            assertParamExists('validateXPlanGmlAsync', 'fileID', fileID)
            const localVarPath = `/verfahren/{planID}/xplanmanager/{fileID}/validateXplanGmlAsync`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"fileID"}}`, encodeURIComponent(String(fileID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (skipSemantisch !== undefined) {
                localVarQueryParameter['skipSemantisch'] = skipSemantisch;
            }

            if (skipGeometrisch !== undefined) {
                localVarQueryParameter['skipGeometrisch'] = skipGeometrisch;
            }

            if (skipFlaechenschluss !== undefined) {
                localVarQueryParameter['skipFlaechenschluss'] = skipFlaechenschluss;
            }

            if (skipGeltungsbereich !== undefined) {
                localVarQueryParameter['skipGeltungsbereich'] = skipGeltungsbereich;
            }

            if (skipLaufrichtung !== undefined) {
                localVarQueryParameter['skipLaufrichtung'] = skipLaufrichtung;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * XplanManagerResourceApi - functional programming interface
 * @export
 */
export const XplanManagerResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = XplanManagerResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird ein Planwerk in der XPlanBox gelöscht. Das Verfahren im Cockpit wird aktualisiert.</p><p><b>Benötigte Rechte:</b> PLANWERKE_WRITE or EIGENE_PLANWERKE_WRITE or ADMIN</p>
         * @summary Endpunkt zum Löschen eines Planwerks in der XPlanBox.
         * @param {string} planID die Cockpit PlanID (nicht zu verwechseln mit der PlanID in der XPlanBox)
         * @param {string} fileID FileID vom Planwerk
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteXplanGml(planID: string, fileID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<XplanManagerStatusMessageRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteXplanGml(planID, fileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XplanManagerResourceApi.deleteXplanGml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden die URLs für die WFS- und WMS-Dienste für das angegebene Verfahren geliefert.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt der die URLs für die WMS- und WFS-Dienste eines Verfahrens liefert.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} fileID FileID vom Planwerk
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllXplanExterneUrls(planID: string, fileID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExterneUrlsRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllXplanExterneUrls(planID, fileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XplanManagerResourceApi.getAllXplanExterneUrls']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden Metadaten aller Planwerk aus der XPlanBox ausgeliefert.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt der Metadaten aller Planwerke aus der XPlanBox ausliefert.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllXplanGml(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanInfoRest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllXplanGml(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XplanManagerResourceApi.getAllXplanGml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird der Verfahrensstand vom Verfahren gegen den Rechtsstand und PlanStatus von veröffentlichen Planwerken geprüft.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zur Prüfung des Rechtsstandes und PlanStatus von veröffentlichten Planwerken zum Verfahrensstand des Verfahrens.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} [codeVerfahrensstand] Verfahrensstand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublishedXplanDokumentVerfahrensstandValidation(planID: string, codeVerfahrensstand?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<XplanDokumentVerfahrensstandValidationRest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublishedXplanDokumentVerfahrensstandValidation(planID, codeVerfahrensstand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XplanManagerResourceApi.getPublishedXplanDokumentVerfahrensstandValidation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Liefert den ValidationReport zu einem XplanDokument.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zum Abruf eines ValidationReports.
         * @param {string} planID planID des Verfahrens
         * @param {string} fileID fileID des XPlanGmlArchivs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValidationReport(planID: string, fileID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidationReportAsyncRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValidationReport(planID, fileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XplanManagerResourceApi.getValidationReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird der Verfahrensstand vom Verfahren gegen den Rechtsstand und PlanStatus eines spezifischen Planwerks geprüft.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zur Prüfung des Rechtsstandes und PlanStaus eines spezifischen Planwerks zum Verfahrensstand des Verfahrens.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} fileID FileID vom Planwerk
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVerfahrensstandValidation(planID: string, fileID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<XplanDokumentVerfahrensstandValidationRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVerfahrensstandValidation(planID, fileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XplanManagerResourceApi.getVerfahrensstandValidation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Liefert Updates des XplanDokuments beispielsweise während des Validierungs- und PublicationProzess in Form von Server Sent Events.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zum Abruf von Updates des XplanDokuments während des Validierungs- und PublicationProzess.
         * @param {string} planID planID des Verfahrens
         * @param {string} fileID fileID des XPlanGmlArchivs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listenForXPlanDokumentUpdates(planID: string, fileID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<XplanDokumentRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listenForXPlanDokumentUpdates(planID, fileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XplanManagerResourceApi.listenForXPlanDokumentUpdates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Liefert Updates des XplanDokuments während des Validierungsprozesses in Form vom Server Sent Events.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zum Abruf von Updates des XplanDokuments während des Validierungsprozesses.
         * @param {string} planID planID des Verfahrens
         * @param {string} fileID fileID des XPlanGmlArchivs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listenForXPlanGmlValidationUpdates(planID: string, fileID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidationStatusRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listenForXPlanGmlValidationUpdates(planID, fileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XplanManagerResourceApi.listenForXPlanGmlValidationUpdates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine im System vorhandenes Planwerk in der XPlanBox veröffentlicht.</p><p><b>Benötigte Rechte:</b> PLANWERKE_WRITE or EIGENE_PLANWERKE_WRITE or ADMIN</p>
         * @summary Endpunkt zum Veröffentlichen eines Planwerks in der XPlanBox.
         * @param {string} planID planID des Verfahrens
         * @param {string} fileID fileID des XPlanGmlArchivs
         * @param {PublishXPlanGmlXplanPlanstatus} xplanPlanstatus PlanInfo.PlanStatusEnum des Planwerks
         * @param {boolean} [skipSemantisch] Semantische Validierung überspringen
         * @param {boolean} [skipFlaechenschluss] Flaechenschluss Validierung überspringen
         * @param {boolean} [skipGeltungsbereich] Geltungsbereich Validierung überspringen
         * @param {boolean} [skipLaufrichtung] Laufrichtung Validierung überspringen
         * @param {boolean} [overwrite] Ggf vorhandenes XplanGML im XplanManager ueberschreiben
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishXPlanGml(planID: string, fileID: string, xplanPlanstatus: PublishXPlanGmlXplanPlanstatus, skipSemantisch?: boolean, skipFlaechenschluss?: boolean, skipGeltungsbereich?: boolean, skipLaufrichtung?: boolean, overwrite?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<XplanDokumentRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishXPlanGml(planID, fileID, xplanPlanstatus, skipSemantisch, skipFlaechenschluss, skipGeltungsbereich, skipLaufrichtung, overwrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XplanManagerResourceApi.publishXPlanGml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt können Rasterdaten zu einem Planwerk ausgetauscht werden.<br>  Die vorhandenen Rasterdaten am Planwerk werden komplett entfernt.</p><p><b>Benötigte Rechte:</b> PLANWERKE_WRITE or EIGENE_PLANWERKE_WRITE or ADMIN</p>
         * @summary Endpunkt zum Austauschen von Rasterdaten eines Planwerks in der XPlanBox.
         * @param {Array<File>} file Rasterdateien die ausgetauscht werden sollen
         * @param {string} planID ID vom Verfahren
         * @param {string} fileID FileID vom Planwerk
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadRasterdaten(file: Array<File>, planID: string, fileID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<XplanDokumentRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadRasterdaten(file, planID, fileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XplanManagerResourceApi.uploadRasterdaten']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Optional kann das Planwerk in der XPlanBox veröffentlicht werden.<br><br> Mit diesem Endpunkt wird ein Planwerk in das System hochgeladen.<br> Optional kann das Planwerk in der XPlanBox über den Parameter publish veröffentlicht werden.</p><p><b>Benötigte Rechte:</b> PLANWERKE_WRITE or EIGENE_PLANWERKE_WRITE or ADMIN</p>
         * @summary Endpunkt zum Hochladen eines Planwerks in das System.
         * @param {File} file das XPlanGmlArchiv
         * @param {string} planID planID des Verfahrens
         * @param {UploadXPlanGmlXplanPlanstatus} [xplanPlanstatus] PlanInfo.PlanStatusEnum des Planwerks
         * @param {boolean} [overwrite] Ggf vorhandenes XplanGML im XplanManager ueberschreiben
         * @param {boolean} [publish] true wenn die XplanGML im XplanManager veroeffentlicht werden soll, sonst false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadXPlanGml(file: File, planID: string, xplanPlanstatus?: UploadXPlanGmlXplanPlanstatus, overwrite?: boolean, publish?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<XplanDokumentRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadXPlanGml(file, planID, xplanPlanstatus, overwrite, publish, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XplanManagerResourceApi.uploadXPlanGml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird ein Planwerk in der XPlanBox synchron validiert.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zum Validieren eines Planwerks in der XPlanBox.
         * @param {string} planID planID des Verfahrens
         * @param {string} fileID fileID des XPlanGmlArchivs
         * @param {boolean} [skipSemantisch] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipGeometrisch] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipFlaechenschluss] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipGeltungsbereich] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipLaufrichtung] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {string} [name] Optionale Angabe eines Namens fuer den zu generierenden Report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateXPlanGml(planID: string, fileID: string, skipSemantisch?: boolean, skipGeometrisch?: boolean, skipFlaechenschluss?: boolean, skipGeltungsbereich?: boolean, skipLaufrichtung?: boolean, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidationReportRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateXPlanGml(planID, fileID, skipSemantisch, skipGeometrisch, skipFlaechenschluss, skipGeltungsbereich, skipLaufrichtung, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XplanManagerResourceApi.validateXPlanGml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird ein Planwerk in der XPlanBox asynchron validiert.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zum asynchronen Validieren eines Planwerks in der XPlanBox.
         * @param {string} planID planID des Verfahrens
         * @param {string} fileID fileID des XPlanGmlArchivs
         * @param {boolean} [skipSemantisch] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipGeometrisch] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipFlaechenschluss] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipGeltungsbereich] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipLaufrichtung] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {string} [name] Optionale Angabe eines Namens fuer den zu generierenden Report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateXPlanGmlAsync(planID: string, fileID: string, skipSemantisch?: boolean, skipGeometrisch?: boolean, skipFlaechenschluss?: boolean, skipGeltungsbereich?: boolean, skipLaufrichtung?: boolean, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidationReceipt>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateXPlanGmlAsync(planID, fileID, skipSemantisch, skipGeometrisch, skipFlaechenschluss, skipGeltungsbereich, skipLaufrichtung, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XplanManagerResourceApi.validateXPlanGmlAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * XplanManagerResourceApi - factory interface
 * @export
 */
export const XplanManagerResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = XplanManagerResourceApiFp(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird ein Planwerk in der XPlanBox gelöscht. Das Verfahren im Cockpit wird aktualisiert.</p><p><b>Benötigte Rechte:</b> PLANWERKE_WRITE or EIGENE_PLANWERKE_WRITE or ADMIN</p>
         * @summary Endpunkt zum Löschen eines Planwerks in der XPlanBox.
         * @param {string} planID die Cockpit PlanID (nicht zu verwechseln mit der PlanID in der XPlanBox)
         * @param {string} fileID FileID vom Planwerk
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteXplanGml(planID: string, fileID: string, options?: any): AxiosPromise<XplanManagerStatusMessageRest> {
            return localVarFp.deleteXplanGml(planID, fileID, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden die URLs für die WFS- und WMS-Dienste für das angegebene Verfahren geliefert.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt der die URLs für die WMS- und WFS-Dienste eines Verfahrens liefert.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} fileID FileID vom Planwerk
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllXplanExterneUrls(planID: string, fileID: string, options?: any): AxiosPromise<ExterneUrlsRest> {
            return localVarFp.getAllXplanExterneUrls(planID, fileID, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden Metadaten aller Planwerk aus der XPlanBox ausgeliefert.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt der Metadaten aller Planwerke aus der XPlanBox ausliefert.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllXplanGml(options?: any): AxiosPromise<Array<PlanInfoRest>> {
            return localVarFp.getAllXplanGml(options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird der Verfahrensstand vom Verfahren gegen den Rechtsstand und PlanStatus von veröffentlichen Planwerken geprüft.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zur Prüfung des Rechtsstandes und PlanStatus von veröffentlichten Planwerken zum Verfahrensstand des Verfahrens.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} [codeVerfahrensstand] Verfahrensstand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedXplanDokumentVerfahrensstandValidation(planID: string, codeVerfahrensstand?: string, options?: any): AxiosPromise<Array<XplanDokumentVerfahrensstandValidationRest>> {
            return localVarFp.getPublishedXplanDokumentVerfahrensstandValidation(planID, codeVerfahrensstand, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Liefert den ValidationReport zu einem XplanDokument.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zum Abruf eines ValidationReports.
         * @param {string} planID planID des Verfahrens
         * @param {string} fileID fileID des XPlanGmlArchivs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidationReport(planID: string, fileID: string, options?: any): AxiosPromise<ValidationReportAsyncRest> {
            return localVarFp.getValidationReport(planID, fileID, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird der Verfahrensstand vom Verfahren gegen den Rechtsstand und PlanStatus eines spezifischen Planwerks geprüft.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zur Prüfung des Rechtsstandes und PlanStaus eines spezifischen Planwerks zum Verfahrensstand des Verfahrens.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} fileID FileID vom Planwerk
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVerfahrensstandValidation(planID: string, fileID: string, options?: any): AxiosPromise<XplanDokumentVerfahrensstandValidationRest> {
            return localVarFp.getVerfahrensstandValidation(planID, fileID, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Liefert Updates des XplanDokuments beispielsweise während des Validierungs- und PublicationProzess in Form von Server Sent Events.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zum Abruf von Updates des XplanDokuments während des Validierungs- und PublicationProzess.
         * @param {string} planID planID des Verfahrens
         * @param {string} fileID fileID des XPlanGmlArchivs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listenForXPlanDokumentUpdates(planID: string, fileID: string, options?: any): AxiosPromise<XplanDokumentRest> {
            return localVarFp.listenForXPlanDokumentUpdates(planID, fileID, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Liefert Updates des XplanDokuments während des Validierungsprozesses in Form vom Server Sent Events.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zum Abruf von Updates des XplanDokuments während des Validierungsprozesses.
         * @param {string} planID planID des Verfahrens
         * @param {string} fileID fileID des XPlanGmlArchivs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listenForXPlanGmlValidationUpdates(planID: string, fileID: string, options?: any): AxiosPromise<ValidationStatusRest> {
            return localVarFp.listenForXPlanGmlValidationUpdates(planID, fileID, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine im System vorhandenes Planwerk in der XPlanBox veröffentlicht.</p><p><b>Benötigte Rechte:</b> PLANWERKE_WRITE or EIGENE_PLANWERKE_WRITE or ADMIN</p>
         * @summary Endpunkt zum Veröffentlichen eines Planwerks in der XPlanBox.
         * @param {string} planID planID des Verfahrens
         * @param {string} fileID fileID des XPlanGmlArchivs
         * @param {PublishXPlanGmlXplanPlanstatus} xplanPlanstatus PlanInfo.PlanStatusEnum des Planwerks
         * @param {boolean} [skipSemantisch] Semantische Validierung überspringen
         * @param {boolean} [skipFlaechenschluss] Flaechenschluss Validierung überspringen
         * @param {boolean} [skipGeltungsbereich] Geltungsbereich Validierung überspringen
         * @param {boolean} [skipLaufrichtung] Laufrichtung Validierung überspringen
         * @param {boolean} [overwrite] Ggf vorhandenes XplanGML im XplanManager ueberschreiben
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishXPlanGml(planID: string, fileID: string, xplanPlanstatus: PublishXPlanGmlXplanPlanstatus, skipSemantisch?: boolean, skipFlaechenschluss?: boolean, skipGeltungsbereich?: boolean, skipLaufrichtung?: boolean, overwrite?: boolean, options?: any): AxiosPromise<XplanDokumentRest> {
            return localVarFp.publishXPlanGml(planID, fileID, xplanPlanstatus, skipSemantisch, skipFlaechenschluss, skipGeltungsbereich, skipLaufrichtung, overwrite, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt können Rasterdaten zu einem Planwerk ausgetauscht werden.<br>  Die vorhandenen Rasterdaten am Planwerk werden komplett entfernt.</p><p><b>Benötigte Rechte:</b> PLANWERKE_WRITE or EIGENE_PLANWERKE_WRITE or ADMIN</p>
         * @summary Endpunkt zum Austauschen von Rasterdaten eines Planwerks in der XPlanBox.
         * @param {Array<File>} file Rasterdateien die ausgetauscht werden sollen
         * @param {string} planID ID vom Verfahren
         * @param {string} fileID FileID vom Planwerk
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadRasterdaten(file: Array<File>, planID: string, fileID: string, options?: any): AxiosPromise<XplanDokumentRest> {
            return localVarFp.uploadRasterdaten(file, planID, fileID, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Optional kann das Planwerk in der XPlanBox veröffentlicht werden.<br><br> Mit diesem Endpunkt wird ein Planwerk in das System hochgeladen.<br> Optional kann das Planwerk in der XPlanBox über den Parameter publish veröffentlicht werden.</p><p><b>Benötigte Rechte:</b> PLANWERKE_WRITE or EIGENE_PLANWERKE_WRITE or ADMIN</p>
         * @summary Endpunkt zum Hochladen eines Planwerks in das System.
         * @param {File} file das XPlanGmlArchiv
         * @param {string} planID planID des Verfahrens
         * @param {UploadXPlanGmlXplanPlanstatus} [xplanPlanstatus] PlanInfo.PlanStatusEnum des Planwerks
         * @param {boolean} [overwrite] Ggf vorhandenes XplanGML im XplanManager ueberschreiben
         * @param {boolean} [publish] true wenn die XplanGML im XplanManager veroeffentlicht werden soll, sonst false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadXPlanGml(file: File, planID: string, xplanPlanstatus?: UploadXPlanGmlXplanPlanstatus, overwrite?: boolean, publish?: boolean, options?: any): AxiosPromise<XplanDokumentRest> {
            return localVarFp.uploadXPlanGml(file, planID, xplanPlanstatus, overwrite, publish, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird ein Planwerk in der XPlanBox synchron validiert.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zum Validieren eines Planwerks in der XPlanBox.
         * @param {string} planID planID des Verfahrens
         * @param {string} fileID fileID des XPlanGmlArchivs
         * @param {boolean} [skipSemantisch] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipGeometrisch] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipFlaechenschluss] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipGeltungsbereich] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipLaufrichtung] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {string} [name] Optionale Angabe eines Namens fuer den zu generierenden Report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateXPlanGml(planID: string, fileID: string, skipSemantisch?: boolean, skipGeometrisch?: boolean, skipFlaechenschluss?: boolean, skipGeltungsbereich?: boolean, skipLaufrichtung?: boolean, name?: string, options?: any): AxiosPromise<ValidationReportRest> {
            return localVarFp.validateXPlanGml(planID, fileID, skipSemantisch, skipGeometrisch, skipFlaechenschluss, skipGeltungsbereich, skipLaufrichtung, name, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird ein Planwerk in der XPlanBox asynchron validiert.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
         * @summary Endpunkt zum asynchronen Validieren eines Planwerks in der XPlanBox.
         * @param {string} planID planID des Verfahrens
         * @param {string} fileID fileID des XPlanGmlArchivs
         * @param {boolean} [skipSemantisch] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipGeometrisch] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipFlaechenschluss] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipGeltungsbereich] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {boolean} [skipLaufrichtung] Option zum Auslassen eine Validierung im XPlanValidator
         * @param {string} [name] Optionale Angabe eines Namens fuer den zu generierenden Report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateXPlanGmlAsync(planID: string, fileID: string, skipSemantisch?: boolean, skipGeometrisch?: boolean, skipFlaechenschluss?: boolean, skipGeltungsbereich?: boolean, skipLaufrichtung?: boolean, name?: string, options?: any): AxiosPromise<ValidationReceipt> {
            return localVarFp.validateXPlanGmlAsync(planID, fileID, skipSemantisch, skipGeometrisch, skipFlaechenschluss, skipGeltungsbereich, skipLaufrichtung, name, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * XplanManagerResourceApi - object-oriented interface
 * @export
 * @class XplanManagerResourceApi
 * @extends {BaseAPI}
 */
export class XplanManagerResourceApi extends BaseAPI {
    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird ein Planwerk in der XPlanBox gelöscht. Das Verfahren im Cockpit wird aktualisiert.</p><p><b>Benötigte Rechte:</b> PLANWERKE_WRITE or EIGENE_PLANWERKE_WRITE or ADMIN</p>
     * @summary Endpunkt zum Löschen eines Planwerks in der XPlanBox.
     * @param {string} planID die Cockpit PlanID (nicht zu verwechseln mit der PlanID in der XPlanBox)
     * @param {string} fileID FileID vom Planwerk
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XplanManagerResourceApi
     */
    public deleteXplanGml(planID: string, fileID: string, options?: RawAxiosRequestConfig) {
        return XplanManagerResourceApiFp(this.configuration).deleteXplanGml(planID, fileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden die URLs für die WFS- und WMS-Dienste für das angegebene Verfahren geliefert.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
     * @summary Endpunkt der die URLs für die WMS- und WFS-Dienste eines Verfahrens liefert.
     * @param {string} planID PlanID vom Verfahren
     * @param {string} fileID FileID vom Planwerk
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XplanManagerResourceApi
     */
    public getAllXplanExterneUrls(planID: string, fileID: string, options?: RawAxiosRequestConfig) {
        return XplanManagerResourceApiFp(this.configuration).getAllXplanExterneUrls(planID, fileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden Metadaten aller Planwerk aus der XPlanBox ausgeliefert.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
     * @summary Endpunkt der Metadaten aller Planwerke aus der XPlanBox ausliefert.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XplanManagerResourceApi
     */
    public getAllXplanGml(options?: RawAxiosRequestConfig) {
        return XplanManagerResourceApiFp(this.configuration).getAllXplanGml(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird der Verfahrensstand vom Verfahren gegen den Rechtsstand und PlanStatus von veröffentlichen Planwerken geprüft.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
     * @summary Endpunkt zur Prüfung des Rechtsstandes und PlanStatus von veröffentlichten Planwerken zum Verfahrensstand des Verfahrens.
     * @param {string} planID PlanID vom Verfahren
     * @param {string} [codeVerfahrensstand] Verfahrensstand
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XplanManagerResourceApi
     */
    public getPublishedXplanDokumentVerfahrensstandValidation(planID: string, codeVerfahrensstand?: string, options?: RawAxiosRequestConfig) {
        return XplanManagerResourceApiFp(this.configuration).getPublishedXplanDokumentVerfahrensstandValidation(planID, codeVerfahrensstand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Liefert den ValidationReport zu einem XplanDokument.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
     * @summary Endpunkt zum Abruf eines ValidationReports.
     * @param {string} planID planID des Verfahrens
     * @param {string} fileID fileID des XPlanGmlArchivs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XplanManagerResourceApi
     */
    public getValidationReport(planID: string, fileID: string, options?: RawAxiosRequestConfig) {
        return XplanManagerResourceApiFp(this.configuration).getValidationReport(planID, fileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird der Verfahrensstand vom Verfahren gegen den Rechtsstand und PlanStatus eines spezifischen Planwerks geprüft.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
     * @summary Endpunkt zur Prüfung des Rechtsstandes und PlanStaus eines spezifischen Planwerks zum Verfahrensstand des Verfahrens.
     * @param {string} planID PlanID vom Verfahren
     * @param {string} fileID FileID vom Planwerk
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XplanManagerResourceApi
     */
    public getVerfahrensstandValidation(planID: string, fileID: string, options?: RawAxiosRequestConfig) {
        return XplanManagerResourceApiFp(this.configuration).getVerfahrensstandValidation(planID, fileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Liefert Updates des XplanDokuments beispielsweise während des Validierungs- und PublicationProzess in Form von Server Sent Events.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
     * @summary Endpunkt zum Abruf von Updates des XplanDokuments während des Validierungs- und PublicationProzess.
     * @param {string} planID planID des Verfahrens
     * @param {string} fileID fileID des XPlanGmlArchivs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XplanManagerResourceApi
     */
    public listenForXPlanDokumentUpdates(planID: string, fileID: string, options?: RawAxiosRequestConfig) {
        return XplanManagerResourceApiFp(this.configuration).listenForXPlanDokumentUpdates(planID, fileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Liefert Updates des XplanDokuments während des Validierungsprozesses in Form vom Server Sent Events.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
     * @summary Endpunkt zum Abruf von Updates des XplanDokuments während des Validierungsprozesses.
     * @param {string} planID planID des Verfahrens
     * @param {string} fileID fileID des XPlanGmlArchivs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XplanManagerResourceApi
     */
    public listenForXPlanGmlValidationUpdates(planID: string, fileID: string, options?: RawAxiosRequestConfig) {
        return XplanManagerResourceApiFp(this.configuration).listenForXPlanGmlValidationUpdates(planID, fileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird eine im System vorhandenes Planwerk in der XPlanBox veröffentlicht.</p><p><b>Benötigte Rechte:</b> PLANWERKE_WRITE or EIGENE_PLANWERKE_WRITE or ADMIN</p>
     * @summary Endpunkt zum Veröffentlichen eines Planwerks in der XPlanBox.
     * @param {string} planID planID des Verfahrens
     * @param {string} fileID fileID des XPlanGmlArchivs
     * @param {PublishXPlanGmlXplanPlanstatus} xplanPlanstatus PlanInfo.PlanStatusEnum des Planwerks
     * @param {boolean} [skipSemantisch] Semantische Validierung überspringen
     * @param {boolean} [skipFlaechenschluss] Flaechenschluss Validierung überspringen
     * @param {boolean} [skipGeltungsbereich] Geltungsbereich Validierung überspringen
     * @param {boolean} [skipLaufrichtung] Laufrichtung Validierung überspringen
     * @param {boolean} [overwrite] Ggf vorhandenes XplanGML im XplanManager ueberschreiben
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XplanManagerResourceApi
     */
    public publishXPlanGml(planID: string, fileID: string, xplanPlanstatus: PublishXPlanGmlXplanPlanstatus, skipSemantisch?: boolean, skipFlaechenschluss?: boolean, skipGeltungsbereich?: boolean, skipLaufrichtung?: boolean, overwrite?: boolean, options?: RawAxiosRequestConfig) {
        return XplanManagerResourceApiFp(this.configuration).publishXPlanGml(planID, fileID, xplanPlanstatus, skipSemantisch, skipFlaechenschluss, skipGeltungsbereich, skipLaufrichtung, overwrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt können Rasterdaten zu einem Planwerk ausgetauscht werden.<br>  Die vorhandenen Rasterdaten am Planwerk werden komplett entfernt.</p><p><b>Benötigte Rechte:</b> PLANWERKE_WRITE or EIGENE_PLANWERKE_WRITE or ADMIN</p>
     * @summary Endpunkt zum Austauschen von Rasterdaten eines Planwerks in der XPlanBox.
     * @param {Array<File>} file Rasterdateien die ausgetauscht werden sollen
     * @param {string} planID ID vom Verfahren
     * @param {string} fileID FileID vom Planwerk
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XplanManagerResourceApi
     */
    public uploadRasterdaten(file: Array<File>, planID: string, fileID: string, options?: RawAxiosRequestConfig) {
        return XplanManagerResourceApiFp(this.configuration).uploadRasterdaten(file, planID, fileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Optional kann das Planwerk in der XPlanBox veröffentlicht werden.<br><br> Mit diesem Endpunkt wird ein Planwerk in das System hochgeladen.<br> Optional kann das Planwerk in der XPlanBox über den Parameter publish veröffentlicht werden.</p><p><b>Benötigte Rechte:</b> PLANWERKE_WRITE or EIGENE_PLANWERKE_WRITE or ADMIN</p>
     * @summary Endpunkt zum Hochladen eines Planwerks in das System.
     * @param {File} file das XPlanGmlArchiv
     * @param {string} planID planID des Verfahrens
     * @param {UploadXPlanGmlXplanPlanstatus} [xplanPlanstatus] PlanInfo.PlanStatusEnum des Planwerks
     * @param {boolean} [overwrite] Ggf vorhandenes XplanGML im XplanManager ueberschreiben
     * @param {boolean} [publish] true wenn die XplanGML im XplanManager veroeffentlicht werden soll, sonst false
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XplanManagerResourceApi
     */
    public uploadXPlanGml(file: File, planID: string, xplanPlanstatus?: UploadXPlanGmlXplanPlanstatus, overwrite?: boolean, publish?: boolean, options?: RawAxiosRequestConfig) {
        return XplanManagerResourceApiFp(this.configuration).uploadXPlanGml(file, planID, xplanPlanstatus, overwrite, publish, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird ein Planwerk in der XPlanBox synchron validiert.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
     * @summary Endpunkt zum Validieren eines Planwerks in der XPlanBox.
     * @param {string} planID planID des Verfahrens
     * @param {string} fileID fileID des XPlanGmlArchivs
     * @param {boolean} [skipSemantisch] Option zum Auslassen eine Validierung im XPlanValidator
     * @param {boolean} [skipGeometrisch] Option zum Auslassen eine Validierung im XPlanValidator
     * @param {boolean} [skipFlaechenschluss] Option zum Auslassen eine Validierung im XPlanValidator
     * @param {boolean} [skipGeltungsbereich] Option zum Auslassen eine Validierung im XPlanValidator
     * @param {boolean} [skipLaufrichtung] Option zum Auslassen eine Validierung im XPlanValidator
     * @param {string} [name] Optionale Angabe eines Namens fuer den zu generierenden Report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XplanManagerResourceApi
     */
    public validateXPlanGml(planID: string, fileID: string, skipSemantisch?: boolean, skipGeometrisch?: boolean, skipFlaechenschluss?: boolean, skipGeltungsbereich?: boolean, skipLaufrichtung?: boolean, name?: string, options?: RawAxiosRequestConfig) {
        return XplanManagerResourceApiFp(this.configuration).validateXPlanGml(planID, fileID, skipSemantisch, skipGeometrisch, skipFlaechenschluss, skipGeltungsbereich, skipLaufrichtung, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird ein Planwerk in der XPlanBox asynchron validiert.</p><p><b>Benötigte Rechte:</b> PLANWERKE_READ or EIGENE_PLANWERKE_READ or ADMIN</p>
     * @summary Endpunkt zum asynchronen Validieren eines Planwerks in der XPlanBox.
     * @param {string} planID planID des Verfahrens
     * @param {string} fileID fileID des XPlanGmlArchivs
     * @param {boolean} [skipSemantisch] Option zum Auslassen eine Validierung im XPlanValidator
     * @param {boolean} [skipGeometrisch] Option zum Auslassen eine Validierung im XPlanValidator
     * @param {boolean} [skipFlaechenschluss] Option zum Auslassen eine Validierung im XPlanValidator
     * @param {boolean} [skipGeltungsbereich] Option zum Auslassen eine Validierung im XPlanValidator
     * @param {boolean} [skipLaufrichtung] Option zum Auslassen eine Validierung im XPlanValidator
     * @param {string} [name] Optionale Angabe eines Namens fuer den zu generierenden Report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XplanManagerResourceApi
     */
    public validateXPlanGmlAsync(planID: string, fileID: string, skipSemantisch?: boolean, skipGeometrisch?: boolean, skipFlaechenschluss?: boolean, skipGeltungsbereich?: boolean, skipLaufrichtung?: boolean, name?: string, options?: RawAxiosRequestConfig) {
        return XplanManagerResourceApiFp(this.configuration).validateXPlanGmlAsync(planID, fileID, skipSemantisch, skipGeometrisch, skipFlaechenschluss, skipGeltungsbereich, skipLaufrichtung, name, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const PublishXPlanGmlXplanPlanstatus = {
    FESTGESTELLT: 'FESTGESTELLT',
    IN_AUFSTELLUNG: 'IN_AUFSTELLUNG',
    ARCHIVIERT: 'ARCHIVIERT',
    unknown_default_open_api: 'unknown_default_open_api'
} as const;
export type PublishXPlanGmlXplanPlanstatus = typeof PublishXPlanGmlXplanPlanstatus[keyof typeof PublishXPlanGmlXplanPlanstatus];
/**
 * @export
 */
export const UploadXPlanGmlXplanPlanstatus = {
    FESTGESTELLT: 'FESTGESTELLT',
    IN_AUFSTELLUNG: 'IN_AUFSTELLUNG',
    ARCHIVIERT: 'ARCHIVIERT',
    unknown_default_open_api: 'unknown_default_open_api'
} as const;
export type UploadXPlanGmlXplanPlanstatus = typeof UploadXPlanGmlXplanPlanstatus[keyof typeof UploadXPlanGmlXplanPlanstatus];
